// extracted by mini-css-extract-plugin
export default {"title":"Home_title__5Yj0k","titleBox":"Home_titleBox__jwWCZ","footer":"Home_footer__-I5oD","copyright":"Home_copyright__AN2UE","copyright_letter":"Home_copyright_letter__h0yDh"};